new (window as Window).Swiper('.post-slider', {
	slidesPerView: 1.1,
	slidesPerGroup: 1,
	spaceBetween: 24,
	navigation: {
		nextEl: '.post-slider__next',
		prevEl: '.post-slider__prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 3.1,
			slidesPerGroup: 1,
			spaceBetween: 28,
		},
		576: {
			slidesPerView: 2.1,
			slidesPerGroup: 1,
			spaceBetween: 28,
		},
	},
});
